/**
 * @function modifyCanAppsV1Path
 * @param { Array } paths
 * @returns { string }
 */
export function modifyCanAppsV1Path(paths) {
	let strPath = '/Portal';
	for (let i = 1; i < paths.length; i++) {
		strPath += `/${paths[i]}`;
	}
	return strPath;
}

/**
 * @function modifyCanAppsV3Path
 * @param { Array } paths
 * @returns { string }
 */
export function modifyCanAppsV3Path(paths) {
	let strPath = '';
	for (let i = 2; i < paths.length; i++) {
		strPath += `/${paths[i]}`;
	}
	return strPath;
}

/**
 * @function modifyCanTrackV3Path
 * @param { Array } paths
 * @returns { string }
 */
export function modifyCanTrackV3Path(paths) {
	let strPath = '';
	for (let i = 2; i < paths.length; i++) {
		strPath += `/${paths[i]}`;
	}
	return strPath;
}
